import { render, staticRenderFns } from "./ShareComponent.vue?vue&type=template&id=0cfb1b3c&scoped=true&"
import script from "./ShareComponent.vue?vue&type=script&lang=ts&"
export * from "./ShareComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ShareComponent.vue?vue&type=style&index=0&id=0cfb1b3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfb1b3c",
  null
  
)

export default component.exports